import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class OrgchartNodeService {
    private constructor() {}

    static GetNameInitals = (firstName, lastName) => {
        let initials = firstName.charAt(0);
        if (lastName) {
            initials = firstName.charAt(0) + lastName.charAt(0);
        }

        return initials.toUpperCase();
    };
}
